<template>
	<VSheet class="search-banner d-flex align-center green-darken-20 white--text py-6 px-4 px-md-14">
		<img
			:width="imgWidth"
			:height="imgHeight"
			src="@/assets/images/pharmacy-position.svg"
			alt=""
		>

		<p
			class="slogan ml-6 ml-md-16 mb-0"
			:class="isMobile ? 'text-subtitle-2' : 'text-h3'"
		>
			Trouvez la pharmacie de garde de jour <br> la plus proche de vous, <br> partout en France.
		</p>
	</VSheet>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	@Component
	export default class SearchBanner extends Vue {
		get isMobile(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		}

		get imgWidth(): string {
			return this.isMobile ? '39px' : '59px';
		}

		get imgHeight(): string {
			return this.isMobile ? '55px' : '84px';
		}
	}
</script>

<style lang="scss" scoped>
	.slogan {
		text-transform: none !important;
		line-height: 1.25;

		@media only screen and (max-width: 360px) {
			font-size: .875rem !important;
		}
		@media only screen and (max-width: 335px) {
			font-size: .75rem !important;
		}
	}
</style>
